const BASE_URL = process.env.REACT_APP_API_URL || "https://lerna.3devsnet.com/api/routes";

export default BASE_URL;


//Hostinger: https://lerna.3devsnet.com/api/routes
//Local: http://localhost:3001/routes

//php -S 127.0.0.1:3001 -t .

